import { Component, OnInit } from '@angular/core';
import { LeadserviceService } from '../service/leadservice.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  

  constructor(private route: ActivatedRoute, private servicelead: LeadserviceService) { }

  ngOnInit() {
   
  }
}



// WEBPACK FOOTER //
// ./src/app/menu/menu.component.ts